import React from "react";
import PropTypes from "prop-types";
import MCard from "components/Shared/MCard.tsx";
import { getSubjectAddressFields, getMailingAddressFields } from "typeConstants/mCardDefinitions/addressFields";

class Address extends React.Component {

  constructor(props) {
    super(props);
    this.getFields = this.getFields.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.setCardControls = this.setCardControls.bind(this);
    this.cardControlMethods = null;
  }

  componentDidUpdate(prevProps) {
    const { isUpdating, getData, controlNumber } = this.props;
    if (prevProps.isUpdating && !isUpdating) {
      getData(controlNumber);
    }
  }

  getFields() {
    const {
      subjectProps,
      mailingProps,
      onAddressClick,
    } = this.props;

    let addressClickFunc = null;
    let geoCodes = subjectProps.geocode ? subjectProps.geocode.split(",") : [];
    if (geoCodes.length > 1 && onAddressClick) {
      addressClickFunc = () => onAddressClick("Map", parseFloat(geoCodes[0]), parseFloat(geoCodes[1]));
    }


    return [
      {
        key: "subject-header",
        label: "Subject",
        isLabelOnly: true,
      },
      ...getSubjectAddressFields(subjectProps, addressClickFunc, true),
      {
        key: "mailing-header",
        label: "Mailing",
        isLabelOnly: true,
      },
      ...getMailingAddressFields(mailingProps, addressClickFunc, true),
    ];
  }

  handleEdit(arr, obj) {
    const { update, controlNumber } = this.props;
    if (this.cardControlMethods.runValidation(true)) {
      update(controlNumber, obj);
    }
  }

  setCardControls(cm) {
    this.cardControlMethods = cm;
  }

  render() {
    const { className, isEditable } = this.props;
    return (
      <MCard
        title="Address"
        className={className}
        fields={this.getFields()}
        isEditable={isEditable}
        onEditFinished={this.handleEdit}
        getControlMethods={this.setCardControls}
      />
    );
  }
}

Address.propTypes = {
  controlNumber: PropTypes.number,
  mailingProps: PropTypes.object,
  subjectProps: PropTypes.object,
  className: PropTypes.string,
  update: PropTypes.func,
  isUpdating: PropTypes.bool,
  isEditable: PropTypes.bool,
  getData: PropTypes.func,
  onAddressClick: PropTypes.func,
};

export default Address;
